<template>
    <b-container fluid class="animated fadeIn">
        <h1>Cadastro de Réu Federal</h1>
        <b-modal @show="resetModal" size="lg" ref="modalReuFederal" id="modal-center" scrollable centered :title="titleModal" footer-class="d-flex justify-content-center align-items-center">
            <label class="float-right">(*) campo obrigatório</label>
            <b-form>
                <b-alert 
                    variant="danger" 
                    :show="msgErroFormulario">{{ msgErroFormulario }}</b-alert>
                <b-form-group
                    id="groupNome"
                    label="Nome: *"
                    label-for="nome">
                    <b-form-input
                        maxlength="80"
                        id="nome"
                        name="nome"
                        v-validate="{ required: true , max: 100 }"
                        v-model="reuFederal.nome"
                        type="text"
                        required>
                    </b-form-input>
                </b-form-group>
                <b-form-group
                    id="groupCnpj"
                    label="CNPJ: *"
                    label-for="cnpj">
                    <b-form-input
                        maxlength="80"
                        id="cnpj"
                        name="cnpj"
                        v-validate="{ required: true, min: 18 }"
                        v-model="reuFederal.cnpj"
                        type="text"
                        required
                        v-mask="'XX.XXX.XXX/XXXX-##'">
                    </b-form-input>
                </b-form-group>
                <b-form-group
                    id="groupAtivo"
                    label="Situação: *"
                    label-for="situacao">
                    <b-form-checkbox switch v-model="reuFederal.indAtivo">{{ reuFederal.indAtivo ? 'Ativo' : 'Inativo'}}</b-form-checkbox>
                </b-form-group>
            </b-form>
            <template v-slot:modal-footer="{ ok, cancel }">
                <b-button class="text-center" variant="primary" @click.prevent="salvar" :disabled="inSave">
                    <i class="fa fa-save"></i> Salvar
                </b-button>
                <b-button  variant="primary" @click.prevent="cancel()">
                    <i class="fa fa-reply"></i> Voltar
                </b-button>
            </template>
        </b-modal>
        <b-card>
            <b-row>
                <b-col md="12">
                    <div class="d-flex justify-content-between">
                        <div>
                            <b-button class="mx-1 fonte-branca" v-b-toggle.collapseOpcoesPesquisa variant="primary"><i class="fa fa-filter"></i> Opções de pesquisa</b-button>
                            <CompExibirOcultarColuna 
                                :fields="fields"
                                :showColunms="showColunms" 
                                @toggleColuna="toggleColuna" />
                        </div>
                    </div>
                    <div>
                        <b-collapse id="collapseOpcoesPesquisa" class="mt-2">
                            <b-card class="primary-semi p-2">
                                <b-row>
                                    <b-col xs="12" sm="12" md="12" lg="6" xl="6">
                                        <b-form-group label="Filtrar por:" label-for="filtrarPor" class="text-label">
                                            <multiselect
                                                v-model="filtrarPor"
                                                :show-labels="false"
                                                :options="opcoesFiltro"
                                                :multiple="true"
                                                :close-on-select="false"
                                                :clear-on-select="false"
                                                :preserve-search="true"
                                                placeholder="Selecione"
                                                track-by="id"
                                                label="filtro"
                                            >
                                                <template slot="selection" slot-scope="{ values, search, isOpen }">
                                                    <span
                                                        class="multiselect__single"
                                                        v-if="values.length &amp;&amp; !isOpen"
                                                    >{{ values.length }} selecionado(s)</span>
                                                </template>
                                            </multiselect>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 1).length > 0)">
                                    <b-col xs="12" sm="12" md="12" lg="8" xl="8">
                                        <b-form-group label="Nome:" label-for="nome" class="text-label">
                                            <b-form-input v-model="filtro.nome" type="text" id="nome" maxlength="100" />
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 2).length > 0)">
                                    <b-col xs="12" sm="12" md="12" lg="8" xl="8">
                                        <b-form-group label="CNPJ:" label-for="cnpj" class="text-label">
                                            <the-mask
                                                id="cnpj"
                                                class="form-control"
                                                v-model="filtro.cnpj"
                                                :mask="['XX.XXX.XXX/XXXX-##']"
                                            />
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 3).length > 0)">
                                    <b-col xs="12" sm="12" md="12" lg="8" xl="8">
                                        <b-form-group label="Situação:" label-for="situacao" class="text-label">
                                            <b-form-checkbox-group
                                                id="checkboxSituacao"
                                                v-model="filtro.situacao"
                                                :options="dados.situacao"
                                                name="checkboxSituacao">
                                            </b-form-checkbox-group>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <hr>
                                <b-row>
                                    <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                                        <div class="d-flex justify-content-center align-items-center">
                                            <b-button class="ml-2" variant="secondary" @click="limparFiltro">
                                                <i class="fa fa-eraser"></i> Limpar
                                            </b-button>
                                        </div>
                                    </b-col>
                                </b-row>
                            </b-card>
                        </b-collapse>
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="12">
                    <div class="d-flex justify-content-between">
                        <div>
                            <b-button variant="primary" class="fonte-branca ml-1" @click="filtrar">
                                <i class="fa fa-search"></i> Pesquisar
                            </b-button>
                            <b-button variant="primary" @click.prevent="incluir" class="fonte-branca ml-1">
                                <i class="fa fa-plus"></i> Incluir
                            </b-button>
                            <b-button variant="primary" class="fonte-branca ml-1" :disabled="selecteds.length !== 1" @click.prevent="alterar">
                                <i class="fa fa-pencil"></i> Alterar
                            </b-button>
                        </div>
                    </div>
                </b-col>
            </b-row>
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <b-col xs="12">
                        <div>
                            <b-row class="d-flex justify-content-between">
                                <b-col>
                                    <label class="mt-3">Quantidade: <strong>{{ configTable.rows }}</strong></label>
                                </b-col>
                                <b-col>
                                    <CompPaginacao :configTable="configTable" />
                                </b-col>
                            </b-row>
                            <TabelaReuFederal
                                :resultado="resultado"
                                :fields="fields"
                                :configTable="configTable"
                                :selecteds="selecteds"
                                @sortingChanged="consultar"
                                @consultar="consultar" />
                            <b-row class="d-flex justify-content-between">
                                <b-col></b-col>
                                <b-col>
                                    <CompPaginacao :configTable="configTable" />
                                </b-col>
                            </b-row>
                        </div>
                    </b-col>
                </b-col>
            </b-row>
        </b-card>
    </b-container>
</template>

<script>
import axios from 'axios'
import CompExibirOcultarColuna from '../components/CompBotaoExibirOcultarColuna'
import CompPaginacao from '../components/CompPaginacao'
import TabelaReuFederal from './TabelaReuFederal'

export default {
    name: 'ManterReuFederal',
    components: {
        CompExibirOcultarColuna,
        CompPaginacao,
        TabelaReuFederal
    },
    data() {
        return {
            inSave: false,
            msgErroFormulario: null,
            reuFederal: {
                codReuFederal: null,
                nome: null,
                cnpj: null,
                indAtivo: true
            },
            fields: [
                {
                    key: "selecionar",
                },
            ],
            showColunms: [],
            filtro: {
                nome: null,
                cnpj: null,
                situacao: [1]
            },
            dados: {
                situacao: [
                    { text: 'Ativo', value: 1 },
                    { text: 'Inativo', value: 0 }
                ]
            },
            filtrarPor: [{
                    id: 3,
                    filtro: 'Situação'
                }],
            opcoesFiltro: [
                {
                    id: 1,
                    filtro: 'Nome'
                },
                {
                    id: 2,
                    filtro: 'CNPJ'
                },
                {
                    id: 3,
                    filtro: 'Situação'
                },
            ],
            configTable: {
                perPage: 100,
                sortField: 'nome',
                sortOrder: 'asc',
                currentPage: 1,
                rows: 0,
                checkedAll: false,
                load: false,
            },
            resultado: [],
            selecteds: [],
            titleModal: 'Incluir'
        }
    },
    methods: {

        resetModal() {
            this.reuFederal = {
                codReuFederal: null,
                nome: null,
                cnpj: null,
                indAtivo: true,
            },
            this.msgErroFormulario = null
        },
        /**
         * Salvar
         */
        async salvar(evt) {
            evt.preventDefault()
            this.inSave = true
            this.msgErroFormulario = null

            this.$validator.validateAll().then( async (result) => {
                if (!result) {
                    this.msgErroFormulario = 'Favor preencher os campos obrigatórios (*)'
                    this.inSave = false
                    return
                }

                const urlApi = process.env.VUE_APP_ROOT_API
                const token = JSON.parse(this.$store.getters.getUser).access_token

                const reuFederal = {
                    codReuFederal: this.reuFederal.codReuFederal,
                    nome: this.reuFederal.nome,
                    cnpj: this.reuFederal.cnpj,
                    indAtivo: this.reuFederal.indAtivo
                }

                await axios.post(`${urlApi}/v1/reuFederal/salvar`, reuFederal, {
                    headers: {
                        'Authorization': token,
                        'Content-Type': 'application/json',
                    }
                })
                .then(response => {
                    if(response.data) {
                        this.msgErroFormulario = `${response.data.message}`
                        return
                    }
                    this.$store.commit("setMessages", { message: 'Sucesso', variant: 'success' , errors: ['Operação realizada com sucesso!!!'] });
                    this.$refs['modalReuFederal'].hide()
                    this.selecteds = []
                    this.consultar()
                }).catch((error) => {
                    this.exibirErro(error)
                }).finally(() => {
                    this.inSave = false
                })
            })

        },

        /**
         * Incluir
         */
        incluir(evt) {
            evt.preventDefault()
            this.$refs['modalReuFederal'].show()
            this.titleModal = 'Incluir'
        },

        /**
         * Alterar
         */
        alterar(evt) {
            evt.preventDefault()
            if(!this.selecteds[0]) {
                return
            }
            this.$refs['modalReuFederal'].show()
            this.titleModal = 'Alterar'
            const { codReuFederal, nome, cnpj, indAtivo } = this.selecteds[0]
            this.reuFederal.codReuFederal = codReuFederal
            this.reuFederal.nome = nome
            this.reuFederal.cnpj = cnpj
            this.reuFederal.indAtivo = indAtivo
        },

        /**
         * Consultar divídas
         */
        async consultar() {
            this.selecteds = []
            const urlApi = process.env.VUE_APP_ROOT_API

            const filtro = this.obterFiltro()

            let perPageStr = `&perPage=${this.configTable.perPage}`
            if(this.configTable.perPage === 'Todos') {
                perPageStr = ''
                this.configTable.currentPage = 1
                this.configTable.rows = 0
            }

            this.loadingEnter()
            axios.post(`${urlApi}/v1/reuFederal/consultar?page=${this.configTable.currentPage}${perPageStr}&sortField=${this.configTable.sortField}&sortOrder=${this.configTable.sortOrder}`, filtro, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': JSON.parse(this.$store.getters.getUser).access_token
                }
            })
            .then(response => {
                this.resultado = response.data.resultado
                if(this.configTable.perPage !== 'Todos') {
                    this.configTable.rows = response.data.rows
                }
            }).finally(() => {
                this.loadingExit()
            })

        },

        /**
         * Obter filtro
         */     
        obterFiltro() {
            return {
                nome: (this.filtrarPor.filter(e => e.id == 1).length > 0) ? this.filtro.nome : null,
                cnpj: (this.filtrarPor.filter(e => e.id == 2).length > 0) ? this.filtro.cnpj : null,
                situacoes: (this.filtrarPor.filter(e => e.id == 3).length > 0) ? this.filtro.situacao : null,
            }
        },

        /**
         * Limpar os filtros de pesquisa
         */
        limparFiltro() {
            this.filtro = {
                nome: null,
                cnpj: null,
                situacao: null,
            }
            this.filtrarPor = []
            this.filtrar();
        },

        /**
         * Filtrar a consulta
         */
        filtrar() {
            this.configTable.currentPage = 1
            this.configTable.rows = 0
            this.configTable.checkedAll = false
            this.resultado = []
            this.selecteds = []
            this.consultar()
        },

        /**
         * Lógica dos checks em nível dinâmico
         */
        toggleColuna(i) {
            let ativo;
            if(this.showColunms.includes(i)) {
                this.showColunms.splice(this.showColunms.indexOf(i), 1)
                this.fields[i].thClass = 'd-none'
                this.fields[i].tdClass = 'd-none'
                ativo = false
            } else {
                this.showColunms.push(i)
                this.fields[i].thClass = ''
                this.fields[i].tdClass = ''
                ativo = true
            }

            this.refreshConfigColunm(i, ativo)
        },

        /**
         * Atualiza as configurações de coluna do usuário
         */
        async refreshConfigColunm(i, ativo) {
            const token = JSON.parse(this.$store.getters.getUser).access_token

            const json = {
                codFuncionalidade: this.fields[i].codFuncionalidade,
                codColunaFuncionalidade: this.fields[i].codColunaFuncionalidade,
                ativo,
            }
            const urlApi = process.env.VUE_APP_ROOT_API
            axios.post(`${urlApi}/v1/funcionalidade/atualizarConfiguracao`, json, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            }).catch((error) => {
                this.exibirErro(error)
            })          
        },

        /**
         * Obter configurações de colunas do usuário
         */
        async obterConfiguracaoUsuario() {
            const urlApi = process.env.VUE_APP_ROOT_API
            const token = JSON.parse(this.$store.getters.getUser).access_token
            const funcionalidade = 'reuFederal'

            this.loadingEnter()
            axios.get(`${urlApi}/v1/funcionalidade/obterConfiguracao/${funcionalidade}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            })
            .then(response => {
                response.data.forEach((field, i) => {
                    if(field.ativo) {
                        this.showColunms.push(i + 1)
                    }
                    this.fields.push({
                        key: `${i + 1}`,
                        label: `${field.descricao}`,
                        sortable: true,
                        sortDirection: "desc",
                        class: this.checkClassTable(i),
                        thClass: field.ativo ? '' : 'd-none', tdClass: field.ativo ? '' : 'd-none',
                        codColunaFuncionalidade: field.codColunaFuncionalidade,
                        codFuncionalidade: field.codFuncionalidade
                    })
                })
            })
        },

        /**
         * Exibe erros dos catch
         */
        exibirErro(error) {
            this.$store.commit("setMessages", { message: 'Erro!', errors: [error] });
        },

        /**
         * Verifica 'class' da tabela
         */
        checkClassTable(i) {
            if(i == 1 || i == 2 || i == 3 || i == 4)
                return 'text-center justify-content-center'
            return 'justify-content-center'
        },

        /**
         * Controle do Loading da Tabela
         */
        loadingEnter() {
            this.configTable.load = true
        },

        /**
         * Controle do Loading da Tabela
         */
        loadingExit() {
            this.configTable.load = false
        }
    },
    watch: {
        perPage() {
            this.configTable.currentPage = 1
            this.consultar()
        }
    },
    computed: {
        perPage() {
            return this.configTable.perPage
        },
    },
    mounted() {
        this.$store.commit("setMessages", {});

        this.obterConfiguracaoUsuario()
        this.consultar()

    }
    
}
</script>

<style scoped>

</style>